import {SubTopContents, SubTopWrap} from 'src/styles/common/subtop'
import letterImg from 'src/assets/common/subtop/letterImg.png'
import noticeImg from 'src/assets/common/subtop/noticeImg.png'
import faqImg from 'src/assets/common/subtop/faqImg.png'
import refundImg from 'src/assets/common/subtop/refundImg.png'
import inquiryImg from 'src/assets/common/subtop/InquiryImg.png'
import newsImg from 'src/assets/common/subtop/newsImg.png'
import cancelImg from 'src/assets/common/subtop/cancelImg.png'
import termsImg from 'src/assets/common/subtop/termsImg.png'
import joinImg from 'src/assets/common/subtop/joinImg.png'
import userPageImg from 'src/assets/common/subtop/userPageImg.png'
import fortuneImg from 'src/assets/common/subtop/fortuneImg.png'
import {useLocation} from 'react-router'

type SubTopOptionType = Array<{ path: string, title:string, desc: string, imgSrc: string}>

const SubTop = () => {
    const {pathname} = useLocation()
    const SubTopOption: SubTopOptionType = [
        {path: '/', title: '', desc: '', imgSrc: ''},
        {path: '/healthExample', title: '', desc: '', imgSrc: ''},
        {path: 'notice', title: '공지사항', desc: '서비스관련 공지사항 알려드립니다.', imgSrc: noticeImg},
        {path: 'letter', title: '패밀리레터', desc: '라이프스타일에 유용한 정보 알려드립니다.', imgSrc: letterImg},
        {path: 'cancel', title: '서비스해지', desc: '서비스 해지를 위해서 본인인증이 필요합니다.', imgSrc: cancelImg},
        {path: 'news', title: '새소식', desc: '서비스관련 새소식을 알려드립니다.', imgSrc: newsImg},
        {path: 'terms', title: '이용약관', desc: '휴대폰 가족보호 서비스 이용약관을 알려드립니다.', imgSrc: termsImg},
        {path: 'faq', title: '자주묻는질문', desc: '서비스 이용에 대한 궁금증을 해결해 드립니다.', imgSrc: faqImg},
        {path: 'refund', title: '서비스 환불', desc: '서비스 환불을 위해서 본인 인증이 필요합니다.', imgSrc: refundImg},
        {path: 'inquiry', title: '1:1문의', desc: '서비스 이용에 어려운점이 있나요? 도와드릴게요.', imgSrc: inquiryImg},
        {path: 'join', title: '서비스가입', desc: '떨어져 있어도 늘 함께하는 것처럼 가족과 연결하고 보호합니다.', imgSrc: joinImg},
        {path: 'login', title: '로그인', desc: '회원메뉴 이용을 위해서 본인인증이 필요합니다.', imgSrc: userPageImg},
        {path: 'userPage/main', title: '마이페이지', desc: '휴대폰가족보호 이용 현황을 확인해보세요.', imgSrc: userPageImg},
        {path: 'userPage/letter', title: '패밀리레터', desc: '헬스와 라이프 콘텐츠를 확인하고 소통해 보세요', imgSrc: letterImg},
        {path: 'userPage/fortune', title: '오늘의 운세', desc: '오늘의 운세와 띠별 운세를 확인하고 소통해보세요.', imgSrc: fortuneImg}
    ]
    const FindItem = (element: { path: string }) => {
        return pathname.indexOf(element.path) > 0
    }
    return (
        <>
            {pathname !== '/' && !pathname.includes('healthExample') &&
                <SubTopWrap>
                    <SubTopContents>
                        <div>
                            <p>{SubTopOption?.find(FindItem)?.title}</p>
                            <span>{SubTopOption?.find(FindItem)?.desc}</span>
                        </div>
                        <img src={SubTopOption?.find(FindItem)?.imgSrc} alt=''/>
                    </SubTopContents>
                </SubTopWrap>}
        </>
    )
}
export default SubTop
